/**
 * Phase F — "Add Extra Table" footer button.
 *
 * Visibility (per customer spec):
 *   - breakfast has started
 *   - no status filter active
 *   - no category filter active
 *   - no search query active (managed by Phase H — for now we treat
 *     filters as inert, so visibility reduces to "breakfast started").
 *
 * Placement: full-width, bottom of the grid, after the NR section.
 */
import { useState } from "react";
import { Plus } from "lucide-react";
import AddDynamicTableDialog from "@/components/dialog/AddDynamicTableDialog";

export default function AddExtraTableButton({ visible = true }) {
  const [open, setOpen] = useState(false);

  if (!visible) return null;

  return (
    <>
      <div className="px-3 mt-2">
        <button
          data-testid="add-extra-table-btn"
          onClick={() => setOpen(true)}
          className="w-full flex items-center justify-center gap-2 py-4 rounded-xl bg-white transition-colors hover:bg-gray-50"
          style={{
            border: "1px dashed #BDBDBD",
            color: "#424242",
          }}
        >
          <Plus size={20} style={{ color: "#757575" }} />
          <span className="text-sm font-medium">Add Extra Table</span>
        </button>
      </div>

      <AddDynamicTableDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
